import React from 'react';
import type { NebulaOverviewData } from '../../../../types/nebula-insights';
import { formatUserName } from '../utils';

interface TopArtistsByNebulaProps {
  artists: NebulaOverviewData['topArtists'];
  onSelectConversation?: (conversationId: string) => void;
}

const TopArtistsByNebula: React.FC<TopArtistsByNebulaProps> = ({ artists }) => (
  <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 sm:p-5 h-full">
    <div className="mb-4">
      <h3 className="text-sm font-medium text-gray-900 font-family-messina-sans">
        Top artists by Nebula usage
      </h3>
      <p className="text-xs text-gray-500 font-family-messina-sans mt-1">
        Conversations in selected period
      </p>
    </div>
    {artists.length === 0 ? (
      <p className="text-sm text-gray-500 font-family-messina-sans py-6 text-center">
        No artist activity in this period
      </p>
    ) : (
      <div className="space-y-3">
        {artists.map((artist) => {
          const initials = (artist.artistName || artist.user?.firstname || 'NA')
            .split(' ')
            .map((part) => part[0])
            .join('')
            .slice(0, 2)
            .toUpperCase();

          return (
            <div key={artist.artistId} className="flex items-center gap-3">
              <div className="w-9 h-9 rounded-full bg-gray-100 border border-gray-200 flex items-center justify-center text-xs font-semibold text-gray-700 font-family-messina-sans shrink-0">
                {initials}
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-gray-900 font-family-messina-sans truncate">
                  {artist.artistName || 'Unnamed artist'}
                </p>
                <p className="text-xs text-gray-500 font-family-messina-sans truncate">
                  {formatUserName(artist.user?.firstname, artist.user?.lastname, artist.user?.email || '—')}
                </p>
              </div>
              <div className="text-right shrink-0">
                <p className="text-sm font-semibold text-gray-900 font-family-messina-sans tabular-nums">
                  {artist.conversationCount}
                </p>
                <p className="text-[10px] text-gray-500 font-family-messina-sans">conversations</p>
              </div>
            </div>
          );
        })}
      </div>
    )}
  </div>
);

export default TopArtistsByNebula;
